import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'

// Selectors
import {
  selectCustomerEmail,
  selectCustomerPhone,
  selectStickyBrandingFullName,
} from 'src/store/selectors/customerProfile'

// Assets
import { PhoneSvg, LetterSvg } from 'src/svgs'

// Components
import { Button, Text } from 'src/Components'
import Format from 'src/Components/shared/Format'
import ScheduleTourButton from 'src/Components/homeSearch/ListingDetails/ScheduleTour/ScheduleTourButton'

// Styles
import classNames from 'classnames'
import styles from './StickyBrandingContactInfo.module.scss'

export const StickyBrandingContactInfo = () => {
  const customerPhone = useSelector(selectCustomerPhone)
  const customerEmail = useSelector(selectCustomerEmail)
  const customerFullName = useSelector(selectStickyBrandingFullName)

  return (
    <div
      className={classNames(styles.container, {
        [styles.maxWidth]: !customerPhone && customerFullName,
      })}
    >
      {customerPhone && (
        <Button
          iconStart={PhoneSvg}
          className={styles.btn}
          element='a'
          href={`tel:${customerPhone}`}
        >
          <Text element='span' weight='semibold' className={styles.smallScreen}>
            <FormattedMessage id='StickyBranding.call' defaultMessage='Call' />
          </Text>
          <Text
            element='span'
            weight='semibold'
            className={styles.mediumScreen}
          >
            <Format.Phone value={customerPhone} />
          </Text>
        </Button>
      )}
      <Button
        iconStart={LetterSvg}
        className={styles.btn}
        element='a'
        href={`mailto:${customerEmail}`}
      >
        <Text element='span' weight='semibold'>
          <FormattedMessage id='StickyBranding.email' defaultMessage='Email' />
        </Text>
      </Button>
      <ScheduleTourButton primary className={styles.btn} />
    </div>
  )
}
